import validationRulesApi from "~/api/validation_rules";

const getValidationRulesForRouteName = ({ commit }, ziggyRouteName) => {
  commit("SET_SUBMIT_ROUTE_NAME", ziggyRouteName);
  validationRulesApi.getByRouteName(ziggyRouteName).then((response) => {
    commit("SET_VALIDATION_RULES", response?.rules);
    commit("SET_VALIDATION_MESSAGES", response?.messages);
  });
};
export default {
  getValidationRulesForRouteName,
};
